// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__VEo5-","videoPlayer":"VideoHero_videoPlayer__Bgx9t","content":"VideoHero_content__GBLuD"};